import { Box, Heading, Text } from "@chakra-ui/react";

import AvailableGames from "./AvailableGames";
import { useState } from "react";
import GamePopUp from "./GamePopUp";

function FilteredGames({ games, heading, isPC }) {
  const [hoverItem, setHoverItem] = useState({
    show: false,
    game: null,
    elementRef: null,
  });

  const handleItemHover = (hoverData) => {
    setHoverItem(hoverData);
  };

  return (
    <>
      <Box bgColor='whiteAlpha.500' overflow='hidden' borderRadius='16px'>
        <Heading
          alignItems='center'
          justifyContent='space-between'
          display='flex'
          p='8px'
          bgColor='primary'
          fontSize='2xl'
        >
          <Text>{heading}</Text>
          {/* 
          <Text
            as={Link}
            to='/games'
            _hover={{
              textDecor: "underline",
              opacity: "1",
            }}
            pr='8px'
            opacity='.75'
            fontSize='sm'
          >
            All games &rsaquo;
          </Text> */}
        </Heading>

        <AvailableGames 
          games={games} 
          onItemHover={handleItemHover}
          isPC={isPC}
        />
      </Box>
      <GamePopUp
        game={hoverItem.game}
        elementRef={hoverItem.elementRef}
        isVisible={hoverItem.show}
        isMobile={isPC}
      />
    </>
  );
}

export default FilteredGames;
